<template>
  <div>
    <Head title="Photos" />
    <h1 class="mb-8 text-3xl font-bold">Photos</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Project:</label>
        <select v-model="form.project_id" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/photos/create">
        <span>Upload</span>
        <span class="hidden md:inline">&nbsp;Photos</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Project</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="photo in photos.data" :key="photo.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/photos/${photo.id}/edit`">
                <img class="mr-2" :src="photo.url" width="80" />
                {{ photo.name.length > 50 ? photo.name.slice(0, 50) + '...' : photo.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/photos/${photo.id}/edit`" tabindex="-1">
                {{ photo.project.name }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/photos/${photo.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="photos.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No photos found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="photos.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    photos: Object,
    projects: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        project_id: this.filters.project_id,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/photos', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
